































import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import RadioInput from "./radio-input.vue";
import NumericInput from "./numeric-input.vue";
import { ConfidentValue } from "../store/types";

@Component({
  components: {
    RadioInput,
    NumericInput
  }
})
export default class extends Vue {
  @Prop({ default: () => ({ value: "", confidence: 0 }) })
  public value!: ConfidentValue;
  @Prop({ default: false })
  public active!: boolean;

  private localChanges: ConfidentValue = { value: "", confidence: 0 };

  private onTimeInput(evt: number | "") {
    this.localChanges.value = evt;
    this.changed();
  }
  private onConfidenceInput(value: number) {
    this.localChanges.confidence = value;
    this.changed();
  }

  @Emit("change")
  private changed() {
    return this.localChanges;
  }
}
